import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { usePublicSettings } from "@/lib/publicSettings";

const KEY = "swns_consent_v1";

function loadGa(id) {
  if (!id || window.__gaLoaded) return;
  window.__gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true });
}

export default function CookieBanner() {
  const [consent, setConsent] = useState(undefined);
  const [prefs, setPrefs] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const { tracking } = usePublicSettings();

  useEffect(() => {
    try { setConsent(JSON.parse(localStorage.getItem(KEY)) || null); } catch { setConsent(null); }
    const open = () => { setPrefs(true); setConsent(null); };
    window.addEventListener("open-cookie-prefs", open);
    return () => window.removeEventListener("open-cookie-prefs", open);
  }, []);

  useEffect(() => {
    if (consent?.analytics) loadGa(tracking?.ga4_id);
  }, [consent, tracking]);

  const save = (value) => {
    const c = { analytics: value, at: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(c));
    setConsent(c);
    setPrefs(false);
  };

  if (consent !== null) return null;
  return (
    <div role="dialog" aria-label="Preferenze cookie" data-testid="cookie-banner" className="anim-in fixed inset-x-3 bottom-20 z-[60] mx-auto max-w-xl rounded-2xl border border-blue-100 bg-[#F7F9FD] p-5 shadow-[0_24px_60px_-20px_rgba(15,23,42,0.35)] sm:bottom-6 sm:left-6 sm:right-auto">
      <p className="font-display text-base font-semibold">Rispettiamo la tua privacy</p>
      <p className="mt-2 text-sm leading-relaxed text-slate-600">
        Usiamo solo strumenti tecnici necessari. Con il tuo consenso attiviamo statistiche anonime per migliorare il sito. <Link to="/cookie-policy" className="text-blue-600 underline-offset-2 hover:underline">Cookie policy</Link>
      </p>
      {prefs && (
        <div className="mt-4 space-y-3 rounded-xl bg-slate-50 p-4 text-sm">
          <label className="flex items-center justify-between gap-3"><span>Tecnici necessari</span><input type="checkbox" checked disabled className="h-4 w-4" /></label>
          <label className="flex items-center justify-between gap-3"><span>Statistiche (Google Analytics)</span>
            <input type="checkbox" data-testid="cookie-analytics-toggle" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} className="h-4 w-4 accent-blue-600" />
          </label>
        </div>
      )}
      <div className="mt-4 flex flex-wrap gap-2">
        <button type="button" data-testid="cookie-reject-btn" onClick={() => save(false)} className="btn-ghost !px-4 !py-2">Solo necessari</button>
        {prefs
          ? <button type="button" data-testid="cookie-save-prefs-btn" onClick={() => save(analytics)} className="btn-dark !px-4 !py-2">Salva preferenze</button>
          : <button type="button" data-testid="cookie-prefs-btn" onClick={() => setPrefs(true)} className="btn-ghost !px-4 !py-2">Personalizza</button>}
        <button type="button" data-testid="cookie-accept-all-btn" onClick={() => save(true)} className="btn-primary !px-4 !py-2">Accetta tutto</button>
      </div>
    </div>
  );
}
